module.exports = __webpack_public_path__ + "media/images/seeds/andy-9772506a183c6dc094e7d0f8c503730e.jpeg";